import content from '../../../../src/jeeum/businessContent.json';

export type BusinessLanguage = 'ko' | 'en';

export function getBusinessContent(language: BusinessLanguage) {
  return content[language];
}

export function getBusinessContactHref(language: BusinessLanguage): string {
  const { contact } = getBusinessContent(language);
  return `mailto:${contact.email}?subject=${encodeURIComponent(contact.mailSubject)}&body=${encodeURIComponent(contact.mailBody)}`;
}

export function businessPath(language: BusinessLanguage): string {
  return language === 'ko' ? '/business' : '/en/business';
}

export function businessLanguageFromPath(pathname: string | null | undefined): BusinessLanguage | null {
  const normalized = pathname?.replace(/\/+$/, '');
  if (normalized === '/business') return 'ko';
  if (normalized === '/en/business') return 'en';
  return null;
}
